export default __webpack_public_path__ + "static/media/collapse-icon.100be999.svg";